<template>
  <Layout v-if="showPage">
    <template slot="sidebar">
      <Sidebar></Sidebar>
    </template>
    <template slot="main">
      <Main></Main>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout';
import Sidebar from '@/components/Sidebar';
import Main from '@/components/Main';

export default {
  components: {
    Layout,
    Sidebar,
    Main,
  },
  provide() {
    return {
      checkPageReady: this.checkPageReady,
      reload: this.reload,
    };
  },
  data() {
    return {
      isPageReady: false,
      showPage: false,
    };
  },
  mounted() {
    this.$store.commit('admin/setCurrentAdmin');
    // 获取当前账号是否具有编辑权限
    this.$store.dispatch('admin/checkCurrentAdminPermission');
    Promise.all([
      this.$store.dispatch('meta/fetchMetaData'),
      this.$store.dispatch('device/initDeviceSource'),
      this.$store.dispatch('device/initDeviceConfig'),
      this.$store.dispatch('project/initProjects'),
    ]).then(() => {
      this.showPage = true;
    }).catch(() => {
      this.showPage = true;
    });
  },
  methods: {
    reload() {
      this.showPage = false;
      this.$nextTick(() => {
        this.showPage = true;
      });
    },
    checkPageReady() {
      return this.isPageReady;
    },
  },
};
</script>
